import { PaymentSubmission } from '../../models/paymentSubmissions';
import getPaymentSubmissions from '../../services/paymentSubmissions/getPaymentSubmissions';

export const getAllPaymentSubmissions = async (patientId: string): Promise<PaymentSubmission[]> => {
  try {
    return (await getPaymentSubmissions(patientId)).requestList;
  } catch (err) {
    return [];
  }
};
